import * as invoice from "./invoice";
import {default as InvoiceComponent} from "./main";

export {  invoice, InvoiceComponent };
